import { Cable } from 'lucide-react'
import { FC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { z } from 'zod'

import { zodResolver } from '@hookform/resolvers/zod'

import Field from '@/components/field'
import LoadingButton from '@/components/loading-button'
import { FormProps } from '@/pages/settings/logging'
import TestSumologic from './test'
import { DialogFooter } from '@/components/ui/dialog'

const schema = z
  .object({
    collectorUrl: z.string().min(1, { message: 'Collector URL is required' }),
  })
  .required()

type FormData = z.infer<typeof schema>

type Props = FormProps<'sumologic'>

const SumologicForm: FC<Props> = ({ onSetup, setupTimer, onTest, testTimer }) => {
  const form = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      collectorUrl: '',
    },
    mode: 'onChange',
  })

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSetup)}>
        <Field<FormData> label="Collector URL" name="collectorUrl" placeholder="Enter your Sumologic collector URL" />

        <DialogFooter className="flex gap-4">
          <TestSumologic timer={testTimer} onTest={() => onTest(form.getValues())} />
          <LoadingButton timer={setupTimer} type="submit" className="w-full">
            <Cable className="w-4 h-4 mr-2" />
            Connect Sumologic
          </LoadingButton>
        </DialogFooter>
      </form>
    </FormProvider>
  )
}

export default SumologicForm
